/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ agency: NonNullable<unknown> }} Portalframe_Denied_BodyInputs */

const en_portalframe_denied_body = /** @type {(inputs: Portalframe_Denied_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.agency} has not opened this part of your portal. Send them a message and they can turn it on.`)
};

/** @type {(inputs: Portalframe_Denied_BodyInputs) => LocalizedString} */
const ar_portalframe_denied_body = en_portalframe_denied_body;

/** @type {(inputs: Portalframe_Denied_BodyInputs) => LocalizedString} */
const he_portalframe_denied_body = en_portalframe_denied_body;

/** @type {(inputs: Portalframe_Denied_BodyInputs) => LocalizedString} */
const ur_portalframe_denied_body = en_portalframe_denied_body;

/** @type {(inputs: Portalframe_Denied_BodyInputs) => LocalizedString} */
const es_portalframe_denied_body = en_portalframe_denied_body;

/** @type {(inputs: Portalframe_Denied_BodyInputs) => LocalizedString} */
const fr_portalframe_denied_body = en_portalframe_denied_body;

/** @type {(inputs: Portalframe_Denied_BodyInputs) => LocalizedString} */
const de_portalframe_denied_body = en_portalframe_denied_body;

/** @type {(inputs: Portalframe_Denied_BodyInputs) => LocalizedString} */
const pt_portalframe_denied_body = en_portalframe_denied_body;

/** @type {(inputs: Portalframe_Denied_BodyInputs) => LocalizedString} */
const hi_portalframe_denied_body = en_portalframe_denied_body;

/** @type {(inputs: Portalframe_Denied_BodyInputs) => LocalizedString} */
const bn_portalframe_denied_body = en_portalframe_denied_body;

/**
* | output |
* | --- |
* | "{agency} has not opened this part of your portal. Send them a message and they can turn it on." |
*
* @param {Portalframe_Denied_BodyInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalframe_denied_body = /** @type {((inputs: Portalframe_Denied_BodyInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalframe_Denied_BodyInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalframe_denied_body(inputs)
	if (locale === "he") return he_portalframe_denied_body(inputs)
	if (locale === "ur") return ur_portalframe_denied_body(inputs)
	if (locale === "es") return es_portalframe_denied_body(inputs)
	if (locale === "fr") return fr_portalframe_denied_body(inputs)
	if (locale === "de") return de_portalframe_denied_body(inputs)
	if (locale === "pt") return pt_portalframe_denied_body(inputs)
	if (locale === "hi") return hi_portalframe_denied_body(inputs)
	if (locale === "bn") return bn_portalframe_denied_body(inputs)
	return en_portalframe_denied_body(inputs)
});